import React from 'react';
import {Button as MuiButton, ButtonProps} from '@mui/material';

export const Button = (props: ButtonProps & {to?: string}) => {
  const {variant = 'contained', size = 'small', ...rest} = props;
  return <MuiButton variant={variant} size={size} {...rest} />;
};
